<template>
  <v-row no-gutters>
    <feature-card-treeview ref="featureCard" :layer="layer" card-title-based-on-tree-element>
      <template #treeview-top="data">
        <sidebar-row class="pr-5 pt-3">
          <v-row no-gutters>
            <v-col cols="auto">
              <base-button
                class="mb-2 text-body-2"
                translation-path="sidebar.requirementsCard"
                @click="generateReport(data.mainLayerName, data.mainLayerFeatureId, true)"
                :loading="
                  loading &&
                    currentReportGeneratingLayerId == data.mainLayerName &&
                    currentReportGeneratingFeatureId == data.mainLayerFeatureId
                "
                :disabled="
                  loading &&
                    (currentReportGeneratingLayerId != data.mainLayerName ||
                      currentReportGeneratingFeatureId != data.mainLayerFeatureId)
                "
              />
            </v-col>
          </v-row>
        </sidebar-row>
      </template>
      <template #additionalElements="item">
        <base-rounded-button
          v-if="item.id !== 'new' && item.metadata.datasource !== masterplanStreetsDataSourceName"
          color="rgba(235, 235, 235, 0.5)"
          iconColor="#202124"
          loaderColor="#202124"
          inner-text="PDF"
          :innerTextClasses="['font-weight-bold', 'font-pdf-button']"
          :custom-size="30"
          @click.stop="generateReport(item.metadata.layer, item.id, false)"
          :loading="
            loading &&
              currentReportGeneratingLayerId == item.metadata.layer &&
              currentReportGeneratingFeatureId == item.id
          "
          :disabled="
            loading &&
              (currentReportGeneratingLayerId != item.metadata.layer || currentReportGeneratingFeatureId != item.id)
          "
          :tooltip="$i18n.t('default.generatePdf')"
        />
      </template>
    </feature-card-treeview>
  </v-row>
</template>
<script>
import { call, get } from 'vuex-pathify';
import FeatureCardTreeview from '@/components/FeatureCardTreeview';
import SidebarRow from '@/components/SidebarRow';
export default {
  name: 'FeatureCardStreetTreeview',
  components: { FeatureCardTreeview, SidebarRow },
  props: {
    layer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    masterplanStreetsDataSourceName: get('admin/modulesMapping@masterplan_streets.street_datasource_name'),
  },
  data: () => ({
    currentReportGeneratingLayerId: null,
    currentReportGeneratingFeatureId: null,
    loading: false,
  }),
  methods: {
    getFeatureReport: call('zdm/getFeatureReport'),
    getStreetReport: call('zdm/getStreetReport'),
    async generateReport(layerId, featureId, mainObject = false) {
      this.loading = true;
      try {
        const payload = {
          layerId,
          featureId,
        };
        this.currentReportGeneratingLayerId = layerId;
        this.currentReportGeneratingFeatureId = featureId;
        await this[mainObject ? 'getStreetReport' : 'getFeatureReport'](payload);
        this.currentReportGeneratingLayerId = null;
        this.currentReportGeneratingFeatureId = null;
        this.loading = false;
      } catch {
        this.currentReportGeneratingLayerId = null;
        this.currentReportGeneratingFeatureId = null;
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .font-pdf-button {
    font-size: 10px !important;
    margin-left: 24px !important;
  }
}
</style>
